<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" size="fs-real" :ariaLabel="title" :footerActive="false">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{title}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="h-screen bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full"
        >
          <PDFViewerApp
            v-show="showPDF"
            :search="actualFilterContent"
            @pdfViewerOpenHandler="pdfViewerOpenHandler"
            :pdf="url"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from '../base/BaseDialogButton.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
// import { descargarPdf } from '@/services/notifications/descargarPdf'
import { downloadMaestroDocumento } from '@/services/notifications/downloadMaestroDocumento'
import { descargardocumentodiligencia } from '@/services/procedings/descargardocumentodiligencia'

export default
{
  name: 'pdf-viewer-dialog',
  components: {
    BaseDialogButton,
    PDFViewerApp,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Visualizador de PDF'
    },
    idAdjunto: {
      type: Number,
      default: -1
      // default: 12125
    },
    isDiligencia: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      actualFilterContent: null,
      url: '',
      showPDF: false,
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.actualFilterContent = null
      this.showPDF = false
      if (value) {
        this.loadPDF()
      } else {
        this.url = ''
      }
    }
  },
  mounted: async function () {
  },
  computed: {
  },
  methods: {
    loadPDF: async function () {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          // idAdjunto: this.idAdjunto,
          // isDiligencia: this.idAdjunto,
          automatico: true
        }
        if (this.isDiligencia) {
          params.idDiligencia = this.idAdjunto
        } else {
          params.idAdjunto = this.idAdjunto
        }

        const adjunto = this.isDiligencia ? await descargardocumentodiligencia(params) : await downloadMaestroDocumento(params)
        const blob = new Blob([adjunto.data], {
          type: 'application/pdf'
        })
        const url = URL.createObjectURL(blob)
        
        setTimeout(() => {
          this.url = url
        }, 1000)
      // window.open(url)
      } catch (error) {
        this.doFeedback('Error al descargar el adjunto')
      } finally {
        setTimeout(() => {
          this.showPDF = true
        }, 200)
      }
    },
    toggleDialog: async function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
  }
}
</script>

<style lang="scss" scoped>
.container-visualizador-pdf {
  height: 100%;
}
</style>
